<template>
  <el-dialog
    custom-class="theme-dialog share-history-container"
    title="立即分享"
    :visible="true"
    @close="onClose"
    :close-on-click-modal="false"
    width="974px"
  >
    <div class="share-history clearfix">
      <div class="float-left w-1/2 pr-3 box-border h-full">
        <share-qr-code class="shadow-box h-full" :url="url" />
      </div>
      <div class="float-left w-1/2 pr-l box-border h-full" v-loading="!isLoad">
        <template v-if="historyList.length">
          <div class="container-box h-full flex flex-col">
            <div class="shadow-box relative py-4 flex px-6 text-theme-black-450">
              <div class="flex-1">
                <div>
                  <div>
                    <span class="text-small">分享总人数(人)</span>
                  </div>
                  <div class="text-large-x text-theme-black-850">{{ historyList.length }}</div>
                </div>
              </div>
              <template v-if="hadShare">
                <div class="line"></div>
                <div class="flex-1">
                  <div class="ml-4">
                    <div>
                      <span class="text-small">分享领取金额合计(元)</span>
                    </div>
                    <div class="text-large-x text-theme-black-850">{{ totalAmount }}</div>
                  </div>
                </div>
              </template>
            </div>
            <div class="shadow-box p-4 mt-4 flex-1 overflow-auto">
              <ul>
                <li v-for="(item, index) in historyList" :key="index" class="history-item-wrap">
                  <share-history-item :item="item" />
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template v-else-if="isLoad">
          <div class="text-center px-10 h-full shadow-box pt-10 box-border">
            <img src="~@/assets/img/empty.png" alt="" class="max-w-full" />
            <div>暂无数据</div>
          </div>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ShareHistoryItem from '@/components/popup/c/ShareHistoryItem'
import ShareQrCode from '@/components/popup/c/ShareQrCode'
import { busGetters, getShareAnswer } from 'dygc'

export default {
  name: 'ShareHistoryPopup',
  components: { ShareQrCode, ShareHistoryItem },
  props: {
    accountUserId: {
      type: String,
      default: ''
    },
    accountUserFingerprint: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    answerId: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      historyList: [],
      isLoad: false
    }
  },
  computed: {
    totalAmount() {
      return this.historyList.reduce((res, item) => {
        if (item.amount) {
          return Number(Number(res) + item.amount).toFixed(2)
        }
        return res
      }, 0)
    },
    ...busGetters(['hadShare'])
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getShareAnswer(this.answerId).then(res => {
        this.historyList = res.data
        this.isLoad = true
      })
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
